import {combineReducers} from "redux";
import settings from "./settingsReducer";
import langList from "./langListReducer";
import error from "./errorReducer";
import loading from "./loadingReducer"
import responseErrors from "./responseErrorsReducer";
import path from "./pathReducer";
import cards from "./cardsReducer";
import timer from "./timerReducer"
import winner from "./winnerReducer"
import gameIsActive from "./gameIsActiveReducer"
import turn from "./turnReducer";
import roundId from "./roundIdReducer";


const rootReducer = combineReducers({
    langList,
    error,
    loading,
    responseErrors,
    path,
    settings,
    cards,
    timer,
    winner,
    gameIsActive,
    turn,
    roundId
});

export default rootReducer;
